import { dew as _indexDew } from "../../../index";
import { dew as _AbstractTimeExpressionParserDew } from "../../../common/parsers/AbstractTimeExpressionParser";
import { dew as _constantsDew } from "../constants";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const index_1 = _indexDew();
  const AbstractTimeExpressionParser_1 = _AbstractTimeExpressionParserDew();
  const constants_1 = _constantsDew();
  class RUTimeExpressionParser extends AbstractTimeExpressionParser_1.AbstractTimeExpressionParser {
    constructor(strictMode) {
      super(strictMode);
    }
    patternFlags() {
      return constants_1.REGEX_PARTS.flags;
    }
    primaryPatternLeftBoundary() {
      return `(^|\\s|T|(?:[^\\p{L}\\p{N}_]))`;
    }
    followingPhase() {
      return `\\s*(?:\\-|\\–|\\~|\\〜|до|и|по|\\?)\\s*`;
    }
    primaryPrefix() {
      return `(?:(?:в|с)\\s*)??`;
    }
    primarySuffix() {
      return `(?:\\s*(?:утра|вечера|после полудня))?(?!\\/)${constants_1.REGEX_PARTS.rightBoundary}`;
    }
    extractPrimaryTimeComponents(context, match) {
      const components = super.extractPrimaryTimeComponents(context, match);
      if (components) {
        if (match[0].endsWith("\u0432\u0435\u0447\u0435\u0440\u0430")) {
          const hour = components.get("hour");
          if (hour >= 6 && hour < 12) {
            components.assign("hour", components.get("hour") + 12);
            components.assign("meridiem", index_1.Meridiem.PM);
          } else if (hour < 6) {
            components.assign("meridiem", index_1.Meridiem.AM);
          }
        }
        if (match[0].endsWith("\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0434\u043D\u044F")) {
          components.assign("meridiem", index_1.Meridiem.PM);
          const hour = components.get("hour");
          if (hour >= 0 && hour <= 6) {
            components.assign("hour", components.get("hour") + 12);
          }
        }
        if (match[0].endsWith("\u0443\u0442\u0440\u0430")) {
          components.assign("meridiem", index_1.Meridiem.AM);
          const hour = components.get("hour");
          if (hour < 12) {
            components.assign("hour", components.get("hour"));
          }
        }
      }
      return components;
    }
  }
  exports.default = RUTimeExpressionParser;
  //# sourceMappingURL=RUTimeExpressionParser.js.map
  return exports;
}